<template>
  <div>
    <div>
      <div class="d-flex justify-space-between">
        <h2 class="font-24 font-lg-28 font-weight-bold primary--text">
          Your details
        </h2>
        <BaseButton
          :text="$vuetify.breakpoint.lgAndUp ? 'Save &amp; exit' : 'Save'"
          flat
          depressed
          ripple
          class="font-weight-bold px-1 py-3"
          icon="mdi-content-save"
          color="#106175"
          small
          @click="saveAndExit"
        />
      </div>
    </div>

    <!-- the form -->
    <ValidationObserver ref="observerFormDetails">
      <form @submit.prevent="onSubmit">
        <BaseLabel
          :hintText="LABEL_CONSTANTS.INSURED_PARTY_RP_HINT_TEXT"
          :text="LABEL_CONSTANTS.INSURED_PARTY_RP_TEXT"
          class="mt-10 mb-2"
        />
        <BaseToggleButton
          v-model="insuredPartyLocal"
          :toggleButtonText="{
            yes: $vuetify.breakpoint.lgAndUp ? 'Letting Agent' : 'Agent',
            yesDataUiid: 'InsuredParty_LettingAgent',
            no: $vuetify.breakpoint.lgAndUp ? 'Private Landlord' : 'Landlord',
            noDataUiid: 'InsuredParty_PrivateLandlord',
          }"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          :min-width="$vuetify.breakpoint.lgAndUp ? '177' : ''"
        />
        <!-- Letting Agent selected -->
        <template v-if="insuredPartyLocal">
          <BaseLabel text="Company name" class="mt-10 mb-2" />
          <BaseInput
            :vid="companyName.InterfaceKey"
            v-model="companyName.Value"
            dataUiid="CompanyName"
            :hideDetails="false"
            :rules="companyNameRule"
            :style="{
              'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
            }"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          />

          <BaseLabel :text="'Company telephone number'" class="mb-2 mt-3" />
          <BaseInput
            :vid="applicant1TelNo.InterfaceKey"
            v-model="applicant1TelNo.Value"
            :rules="applicant1TelNoRules"
            :hide-details="false"
            type="tel"
            name="Company telephone number"
            :style="{
              'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
            }"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          />

          <BaseLabel :text="LABEL_CONSTANTS.TITLE_LABEL" class="mt-3 mb-2" />
          <BaseSelect
            dense
            :vid="questionApplicant1Title.InterfaceKey"
            v-model="questionApplicant1Title.Value"
            :items="applicant1TitleOptions"
            :data-uiid="questionApplicant1Title.InterfaceKey"
            :isEnableSortOrderListItems="false"
            :hide-details="false"
            :selectedDefault="LABEL_CONSTANTS.SELECT_DEFAULT_PLACEHOLDER"
            :rules="{
              required: {
                required: true,
                fieldLabel: LABEL_CONSTANTS.TITLE_LABEL,
              },
            }"
            :style="{
              'max-width': $vuetify.breakpoint.lgAndUp ? '280px' : '100%',
            }"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          />

          <BaseLabel
            :text="LABEL_CONSTANTS.FIRST_NAME_LABEL"
            class="mt-3 mb-2"
          />
          <BaseInput
            :vid="questionApplicant1Forename.InterfaceKey"
            v-model="questionApplicant1Forename.Value"
            :data-uiid="questionApplicant1Forename.InterfaceKey"
            :hide-details="false"
            :rules="applicantFirstNameRules"
            :style="{
              'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
            }"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          />

          <BaseLabel
            :text="LABEL_CONSTANTS.LAST_NAME_LABEL"
            class="mt-3 mb-2"
          />
          <BaseInput
            :vid="questionApplicant1Surname.InterfaceKey"
            v-model="questionApplicant1Surname.Value"
            :data-uiid="questionApplicant1Surname.InterfaceKey"
            :hide-details="false"
            :rules="applicantLastNameRules"
            :style="{
              'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
            }"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          />
        </template>

        <!-- Private Landlord selected -->
        <template v-else>
          <BaseLabel :text="LABEL_CONSTANTS.TITLE_LABEL" class="mt-10 mb-2" />
          <BaseSelect
            dense
            :vid="questionApplicant1Title.InterfaceKey"
            v-model="questionApplicant1Title.Value"
            :items="applicant1TitleOptions"
            :data-uiid="questionApplicant1Title.InterfaceKey"
            :isEnableSortOrderListItems="false"
            :hide-details="false"
            :selectedDefault="LABEL_CONSTANTS.SELECT_DEFAULT_PLACEHOLDER"
            :rules="{
              required: {
                required: true,
                fieldLabel: LABEL_CONSTANTS.TITLE_LABEL,
              },
            }"
            :style="{
              'max-width': $vuetify.breakpoint.lgAndUp ? '280px' : '100%',
            }"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          />

          <BaseLabel
            :text="LABEL_CONSTANTS.FIRST_NAME_LABEL"
            class="mt-3 mb-2"
          />
          <BaseInput
            :vid="questionApplicant1Forename.InterfaceKey"
            v-model="questionApplicant1Forename.Value"
            :data-uiid="questionApplicant1Forename.InterfaceKey"
            :hide-details="false"
            :rules="applicantFirstNameRules"
            :style="{
              'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
            }"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          />

          <BaseLabel
            :text="LABEL_CONSTANTS.LAST_NAME_LABEL"
            class="mt-3 mb-2"
          />
          <BaseInput
            :vid="questionApplicant1Surname.InterfaceKey"
            v-model="questionApplicant1Surname.Value"
            :data-uiid="questionApplicant1Surname.InterfaceKey"
            :hide-details="false"
            :rules="applicantLastNameRules"
            :style="{
              'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
            }"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          />

          <BaseLabel
            :text="LABEL_CONSTANTS.DATE_OF_BIRTH_LABEL"
            class="mt-3 mb-2"
          />
          <BaseInputDate
            :vid="questionApplicant1DoB.InterfaceKey"
            :data-uiid="questionApplicant1DoB.InterfaceKey"
            :value="questionApplicant1DoB.Value"
            v-model="questionApplicant1DoB.Value"
            :rules="applicantDateOfBirthRules"
            :hideDetails="false"
            :style="{
              'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
            }"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          />

          <BaseLabel :text="'Telephone number'" class="mb-2 mt-3" />
          <BaseInput
            :vid="applicant1TelNo.InterfaceKey"
            v-model="applicant1TelNo.Value"
            :rules="applicant1TelNoRules"
            :hide-details="false"
            type="tel"
            name="Telephone number"
            :style="{
              'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
            }"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          />
        </template>

        <BaseButton
          depressed
          rounded
          dense
          class="font-weight-bold font-20 pa-7 px-13 mt-4 primary--text"
          type="submit"
          :color="'psorange'"
          :block="$vuetify.breakpoint.lgAndUp ? false : true"
          :text="
            $vuetify.breakpoint.lgAndUp
              ? 'CONTINUE TO COVER DETAILS'
              : 'CONTINUE'
          "
        />
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { EventBus } from "@/common/eventbus.js";
import { addFieldLabel, scrollTop, tryGoToNextStep } from "@/common/utils";
import { ROUTE_NAME } from "@/constants/route.constants";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import { mapActions, mapState } from "vuex";
import { INSURED_PARTY } from "@/constants/common.constants";
import {
  APPLICANT_TITLE_ITEMS,
  setItemDataUiids,
} from "@/constants/component.constants";
import * as LABEL_CONSTANTS from "@/constants/label.constants";
import {
  ERROR_INVALID,
  ERROR_MSG_MAX_CHARACTER,
  ERROR_NAME_INVALID,
} from "@/constants/message.constants.js";
import { DATE_REGEX, NAME_REGEX } from "@/constants/regex-patterns.constants";

import BaseButton from "@/components/BaseComponents/BaseButton";
import BaseInput from "@/components/BaseComponents/BaseInput";
import BaseInputDate from "@/components/BaseComponents/BaseInputDate";
import BaseLabel from "@/components/BaseComponents/BaseLabel";
import BaseSelect from "@/components/BaseComponents/BaseSelect";
import BaseToggleButton from "@/components/BaseComponents/BaseToggleButton";
import { ValidationObserver } from "vee-validate";
// import { numbersToWords } from "@/common/answers";

export default {
  name: "YourDetailsPage",
  components: {
    ValidationObserver,
    BaseLabel,
    BaseToggleButton,
    BaseInput,
    BaseInputDate,
    BaseButton,
    BaseSelect,
  },
  data() {
    return {
      questionApplicant1DoB: {},
      questionApplicant1Forename: {},
      questionApplicant1Surname: {},
      questionApplicant1Title: {},
      questionApplicant1Student: {},
      questionSecondApplicantIncluded: {},
      questionPreviousHeld: {
        InterfaceKey: "HeldInsurance",
        Value: false,
      },
      companyName: "",
      applicant1TelNo: {},
      NAME_REGEX,
      DATE_REGEX,
      LABEL_CONSTANTS,
      ERROR_NAME_INVALID,
      ERROR_MSG_MAX_CHARACTER,
      ERROR_INVALID,
      APPLICANT_TITLE_ITEMS,
      insuredParty: null,
      insuredPartyLocal: true,
      companyNameRule: addFieldLabel(
        {
          required: {
            required: true,
          },
          maxLength: {
            length: 100,
          },
        },
        "Company name"
      ),

      applicantDateOfBirthRules: addFieldLabel(
        {
          required: {
            required: true,
          },
          date_valid: {
            errorMessageTemplate: ERROR_INVALID,
          },
          regex: {
            errorMessageTemplate: ERROR_INVALID,
            pattern: DATE_REGEX,
          },
          age_in_range: {
            min: 18,
            max: 105,
          },
        },
        LABEL_CONSTANTS.DATE_OF_BIRTH_LABEL
      ),
      applicantFirstNameRules: addFieldLabel(
        {
          required: {
            required: true,
          },
          max: {
            length: 50,
            errorMessageTemplate: ERROR_MSG_MAX_CHARACTER,
          },
          min_length: {
            length: 2,
          },
          regex: {
            pattern: NAME_REGEX,
            customMessage: ERROR_NAME_INVALID,
          },
        },
        LABEL_CONSTANTS.FIRST_NAME_LABEL
      ),
      applicantLastNameRules: addFieldLabel(
        {
          required: {
            required: true,
          },
          max: {
            length: 100,
            errorMessageTemplate: ERROR_MSG_MAX_CHARACTER,
          },
          min_length: {
            length: 2,
          },
          regex: {
            pattern: NAME_REGEX,
            customMessage: ERROR_NAME_INVALID,
          },
        },
        LABEL_CONSTANTS.LAST_NAME_LABEL
      ),
    };
  },
  computed: {
    ...mapState(QUESTIONS_MODULE, [
      "quoteResponse",
      "questionMap",
      "restoringLastStep",
    ]),
    applicant1TitleOptions() {
      return setItemDataUiids("Applicant1Title", this.APPLICANT_TITLE_ITEMS);
    },
    telephoneLabel() {
      return this.insuredPartyLocal
        ? "Company telephone number"
        : "Telephone number";
    },
    applicant1TelNoRules() {
      return addFieldLabel(
        {
          required: {
            required: true,
          },
          phone_number: {},
        },
        this.telephoneLabel
      );
    },
  },
  beforeMount() {
    this.onSetupAndLoadSavedData();
    scrollTop();
  },
  mounted() {
    this.setCurrentRefObserverForm(this.$refs.observerFormDetails);

    if (!this.restoringLastStep) {
      return;
    }

    //work around running validate before the data has been added to input
    setTimeout(async () => {
      tryGoToNextStep(
        this.$refs.observerFormDetails,
        async (form) => await form.validate(),
        ROUTE_NAME.RENT_PROTECTION.B2B.COVER_DETAILS
      );
    }, 0);
  },
  watch: {
    insuredPartyLocal(val) {
      if (val) {
        this.insuredParty.Value = "LettingAgent";
        this.questionApplicant1DoB.Value = "";
      } else {
        this.insuredParty.Value = "PrivateLandlord";
        this.companyName.Value = "";
      }
    },
  },
  methods: {
    ...mapActions(QUESTIONS_MODULE, [
      "saveProgress",
      "setIsExpiredFlag",
      "resetInvalidQuestions",
      "toggleGlobalSaveAndExitDialog",
      "setCurrentRefObserverForm",
      "refreshSessionAndNextStep",
    ]),
    setInitialInsuredPartyValues() {
      if (!this.insuredParty.Value) {
        this.insuredParty.Value = INSURED_PARTY.LettingAgent; // default to LettingAgent
      } else if (this.insuredParty.Value === INSURED_PARTY.PrivateLandlord) {
        this.insuredPartyLocal = false; // make the UI match the loaded answer
      }
    },

    onSetupAndLoadSavedData() {
      this.questionApplicant1DoB = this.questionMap["Applicant1DoB"];
      this.questionApplicant1Forename = this.questionMap["Applicant1Forename"];
      this.questionApplicant1Surname = this.questionMap["Applicant1Surname"];
      this.questionApplicant1Title = this.questionMap["Applicant1Title"];
      this.applicant1TelNo = this.questionMap["Applicant1TelNo"];
      this.companyName = this.questionMap["CompanyName"];
      this.insuredParty = this.questionMap["InsuredParty"];
      this.setInitialInsuredPartyValues();
    },

    async onSubmit() {
      const isValidForm = await this.$refs.observerFormDetails.validate();

      if (!isValidForm) {
        setTimeout(() => {
          EventBus.$emit("validation-error", "Validation error occurred");
        }, 100);
        return;
      }

      sessionStorage.removeItem("isNewQuoteFromExpiredQuote");

      this.saveProgress();
      this.refreshSessionAndNextStep(
        ROUTE_NAME.RENT_PROTECTION.B2B.COVER_DETAILS
      );
    },

    onChange(val, name) {
      this.form[name] = val;
    },

    saveAndExit() {
      this.toggleGlobalSaveAndExitDialog();
    },
  },
};
</script>

<style lang="scss" scoped>
.second-applicant-included-field {
  :deep(.v-icon) {
    margin-right: 16px !important;
  }

  :deep(.v-btn) {
    padding: 4px 4px !important;
  }
}
.sub-text {
  font-size: 14px !important;
  font-weight: 400;
}

@media screen and (min-width: $grid-breakpoints-md) {
  .sub-text {
    width: 60% !important;
  }
}
</style>
